import api from './api';

const managementRequest = (config = {}) => ({
  _authContext: 'management',
  ...config,
});

export const getStoresManagementList = async () => {
  const response = await api.get('/stores-management/stores', managementRequest());
  return response.data || [];
};

export const deleteStoreCompletely = async (storeId) => {
  await api.delete(`/stores-management/stores/${storeId}`, managementRequest());
};

export const setStoreAllowSmsOnTrial = async (storeId, allowSmsOnTrial) => {
  await api.put(
    `/stores-management/stores/${storeId}/allow-sms-on-trial`,
    { allowSmsOnTrial },
    managementRequest(),
  );
};
